






import Vue from 'vue';
import BaseButton from './BaseButton.vue';
import ArrowIcon from '../../../assets/img/arrow_go_top.svg';

export default Vue.extend({
    components: { BaseButton, ArrowIcon },
    props: {
        idToScroll: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'big',
        },
        title: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'button',
        },
    },
    methods: {
        scrollTo() {
            if (this.idToScroll) {
                window.document.getElementById(this.idToScroll)?.scrollIntoView();
            } else {
                window.scrollTo(0, 0);
            }
        },
    },
});
